import React from "react";
import RoleCard from "./RoleCard";
import { RoleCardData } from "../data/mockRoles";

interface RolesGridProps {
  roles: RoleCardData[];
  onEditRole: (role: RoleCardData) => void;
  onDeleteRole: (role: RoleCardData) => void;
  onOpenRole: (role: RoleCardData) => void;
  readOnly?: boolean;
}

const RolesGrid: React.FC<RolesGridProps> = ({
  roles,
  onEditRole,
  onDeleteRole,
  onOpenRole,
  readOnly = false,
}) => {
  return (
    <section className="rp-roles-section" aria-label="All roles">
      <div className="rp-roles-grid">
        {roles.map((role) => (
          <RoleCard
            key={role.id}
            role={role}
            onEdit={onEditRole}
            onDelete={onDeleteRole}
            onOpenRole={onOpenRole}
            readOnly={readOnly}
          />
        ))}
      </div>
    </section>
  );
};

export default RolesGrid;
